// Map of activity emojis by gender
export const ACTIVITY_EMOJIS = {
  walk: {
    male: '🚶‍♂️',
    female: '🚶‍♀️'
  },
  run: {
    male: '🏃‍♂️',
    female: '🏃‍♀️'
  },
  wellness: {
    male: '🧘‍♂️',
    female: '🧘‍♀️'
  }
} as const;

export function getRandomGenderEmoji(activity: keyof typeof ACTIVITY_EMOJIS): string {
  const gender = Math.random() < 0.5 ? 'male' : 'female';
  return ACTIVITY_EMOJIS[activity][gender];
}

/**
 * Checks if a string contains only emoji characters
 * @param str The string to check
 * @returns True if the string contains only emoji characters
 */
export function isEmoji(str: string): boolean {
  // Remove whitespace
  const trimmed = str.trim();
  
  // If empty or too long, it's not a single emoji
  if (!trimmed || trimmed.length > 4) return false;
  
  // Emoji regex pattern
  // This covers most standard emojis, including those with variation selectors
  const emojiRegex = /^(\p{Emoji_Presentation}|\p{Emoji}\uFE0F)$/u;
  
  // Test each character in the string
  for (const char of trimmed) {
    if (!emojiRegex.test(char)) {
      // Special case for multi-code point emojis (like flags, skin tones, etc.)
      if (trimmed.length <= 4 && /\p{Emoji}/u.test(trimmed)) {
        return true;
      }
      return false;
    }
  }
  
  return true;
}